import web from '@/web';
import Location from '@/models/Location.ts';

const REFRESH_TIME_MILLIS = 5 * 60 * 1000;  // 5 minutes

let mutations = {
  setLocations(state, locations) {
    state.list = locations;
  },
  setNodes(state, { location, type, nodes }) {
    location.lastLoadDate[type] = new Date();
    location.nodes[type] = nodes;
  },
};

let actions = {
  async loadLocations({ commit, state }) {
    if (!state.lastLoaded || (new Date().getTime() - state.lastLoaded.getTime()) > REFRESH_TIME_MILLIS) {
      state.lastLoaded = new Date();

      const response = await web.getNodes();

      // Combine all locations into a super-list, but add metatags telling if it's owned, accessed, etc.
      var allLocations = [
        ...response.data.owned.map((owned) => new Location(owned, 'owned')),
        ...response.data.accesses.map((accesses) => new Location(accesses.location, 'access')),
        ...response.data.unapproved.map((unapproved) => new Location(unapproved, 'unapproved')),
        ...response.data.pending.map((pending) => new Location(pending, 'pending')),
      ];

      commit('setLocations', allLocations);
    }
    // TODO start reload timer
  },
  async loadNodes({ commit }, { location, nodeType }) {
    if (!location.lastLoadDate[nodeType] || (new Date().getTime() - location.lastLoadDate[nodeType].getTime()) > REFRESH_TIME_MILLIS) {

      location.lastLoadDate[nodeType] = new Date();

      const response = await web.getNodesForLocation(location.id, nodeType);
      commit('setNodes', { location, type: nodeType, nodes: response.data });
    }
  }
};

const locations = {
  state: {
    list: [],
    lastLoaded: null,
  },
  actions,
  mutations,
  getters: {
  }
};
export default locations;
